import { render } from "./PerfomancesView.vue?vue&type=template&id=38725f17&scoped=true"
const script = {}

import "./PerfomancesView.vue?vue&type=style&index=0&id=38725f17&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38725f17"]])

export default __exports__